import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import FormAddAllowedUriScheme, {
  AddAllowedUriSchemeFormData,
} from 'dashboard/forms/FormAddAllowedUriScheme';
import TableLayout, {
  TableActionTD,
  TableNullState,
  TableRemoveRow,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';

const TableContainer = styled('div')`
  margin-bottom: ${SPACINGS.base * 2}px;
`;

interface AllowedUriSchemesListProps {
  allowedUriSchemes: string[];
  addAllowedUriScheme: (values: AddAllowedUriSchemeFormData) => void;
  removeAllowedUriScheme: (uriSchemeIndex: number) => void;
}

export default ({
  allowedUriSchemes,
  addAllowedUriScheme,
  removeAllowedUriScheme,
}: AllowedUriSchemesListProps) => {
  const uriSchemeRows = allowedUriSchemes.map((uriScheme, i) => {
    return (
      <TableTR key={i}>
        {/* TODO: (melissa) make URI schemes unique so we don't have to use i as a key */}
        <TableTD>{uriScheme}</TableTD>
        <TableActionTD>
          <TableRemoveRow onClick={() => removeAllowedUriScheme(i)} />
        </TableActionTD>
      </TableTR>
    );
  });

  return (
    <div>
      <TableContainer>
        <TableLayout
          dataTest='allowed-uri-schemes-list__table'
          isLoading={false}
          isEmpty={allowedUriSchemes.length === 0}
          showHeader={true}
          nullState={
            <TableNullState dataTestBlock='allowed-uri-schemes-list__null-state'>
              No URI schemes on the allowlist.
            </TableNullState>
          }
          headerTR={
            <>
              <TableTH>URI Scheme</TableTH>
              <TableTH>{/* Remove uri scheme column */}</TableTH>
            </>
          }
        >
          {uriSchemeRows}
        </TableLayout>
      </TableContainer>
      <FormAddAllowedUriScheme onSubmit={addAllowedUriScheme} />
    </div>
  );
};
